import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_image = _resolveComponent("base-image")

  return ($options.isImpersonated)
    ? (_openBlock(), _createBlock(_component_base_icon, {
        key: 0,
        name: "id-card",
        size: "lg",
        "is-fixed-width": "",
        class: "_tc--accent"
      }))
    : ($options.hasAvatar)
      ? (_openBlock(), _createBlock(_component_base_image, {
          key: 1,
          alt: "Avatar",
          class: "gfu-avatar",
          src: $options.userProfileAvatarUrl,
          width: $props.avatarSize,
          height: $props.avatarSize,
          "data-qa": "header-actions:Avatar"
        }, null, 8 /* PROPS */, ["src", "width", "height"]))
      : (_openBlock(), _createBlock(_component_base_icon, {
          key: 2,
          name: "user-cog",
          size: "lg",
          "is-fixed-width": ""
        }))
}